import moment from "moment";
import { COMPANY_TYPE_KEY } from "../../../../../common/constants/systemUrls";

export const dataAdjustmentRequest = (data, roleId, userId) => {
  let newData = {
    user: {},
    role_id: roleId,
    company: {}
  };
  if (userId) {
    newData.user.user_id = userId;
  }
  if (
    data.AddAdministrator.adminLastname &&
    data.AddAdministrator.adminLastname !== ""
  ) {
    newData.user.lastname = data.AddAdministrator.adminLastname;
  }
  if (
    data.AddAdministrator.adminName &&
    data.AddAdministrator.adminName !== ""
  ) {
    newData.user.name = data.AddAdministrator.adminName;
  }
  if (
    data.AddAdministrator.adminPatronymic &&
    data.AddAdministrator.adminPatronymic !== ""
  ) {
    newData.user.patronymic = data.AddAdministrator.adminPatronymic;
  }
  if (
    data.AddAdministrator.adminBirthDate &&
    data.AddAdministrator.adminBirthDate !== ""
  ) {
    newData.user.birth_date = data.AddAdministrator.adminBirthDate.format(
      "YYYY-MM-DD"
    );
  }
  if (
    data.AddAdministrator.adminEmail &&
    data.AddAdministrator.adminEmail !== ""
  ) {
    newData.user.email = data.AddAdministrator.adminEmail;
  }
  if (data.AddLicensee.subjectId && data.AddLicensee.subjectId !== "") {
    newData.company.subject_id = parseInt(data.AddLicensee.subjectId);
  }
  if (data.AddLicensee.subjectKey && data.AddLicensee.subjectKey !== "") {
    newData.company.subject_key = data.AddLicensee.subjectKey;
  }
  if (data.AddLicensee.nameLegal && data.AddLicensee.nameLegal !== "") {
    newData.company.name_legal = data.AddLicensee.nameLegal;
  }
  if (data.AddLicensee.addressLegal && data.AddLicensee.addressLegal !== "") {
    newData.company.address_legal = data.AddLicensee.addressLegal;
  }
  // todo нет в данных, но есть для записи
  if (
    data.AddLicensee.registratonDate &&
    data.AddLicensee.registratonDate !== ""
  ) {
    newData.company.registraton_date = data.AddLicensee.registratonDate.format(
      "DD.MM.YYYY"
    );
  }
  if (data.AddLicensee.inn && data.AddLicensee.inn !== "") {
    newData.company.inn = data.AddLicensee.inn;
  }
  if (data.AddLicensee.kpp && data.AddLicensee.kpp !== "") {
    newData.company.kpp = data.AddLicensee.kpp;
  }
  if (data.AddLicensee.ogrn && data.AddLicensee.ogrn !== "") {
    newData.company.ogrn = data.AddLicensee.ogrn;
  }
  if (
    (data.AddLicensee.taxSystem && data.AddLicensee.taxSystem !== "") ||
    data.AddLicensee.taxSystem === 0
  ) {
    newData.company.nds = data.AddLicensee.taxSystem;
  }
  if (data.AddLicensee.email && data.AddLicensee.email !== "") {
    newData.company.email = data.AddLicensee.email;
  }
  if (data.AddLicensee.phoneNumber && data.AddLicensee.phoneNumber !== "") {
    newData.company.phone = data.AddLicensee.phoneNumber;
  }
  if (data.AddLicensee.phoneCode && data.AddLicensee.phoneCode !== "") {
    newData.company.phone_code = data.AddLicensee.phoneCode;
  }
  if (data.AddLicensee.addressFact && data.AddLicensee.addressFact !== "") {
    newData.company.address_fact = data.AddLicensee.addressFact;
  }
  if (data.AddLicensee.web_cite && data.AddLicensee.web_cite !== "") {
    newData.company.site = data.AddLicensee.web_cite;
  }
  if (data.AddLicensee.birthPlace && data.AddLicensee.birthPlace !== "") {
    newData.company.birth_place = data.AddLicensee.birthPlace;
  }
  if (data.AddLicensee.lastname && data.AddLicensee.lastname !== "") {
    newData.company.lastname = data.AddLicensee.lastname;
  }
  if (data.AddLicensee.name && data.AddLicensee.name !== "") {
    newData.company.name = data.AddLicensee.name;
  }
  if (data.AddLicensee.patronymic && data.AddLicensee.patronymic !== "") {
    newData.company.patronymic = data.AddLicensee.patronymic;
  }
  if (data.AddLicensee.birthDate) {
    newData.company.birth_date = data.AddLicensee.birthDate.format(
      "DD.MM.YYYY"
    );
  }
  newData.company.company_type_key = COMPANY_TYPE_KEY;
  if (data.addTariff.tariff_type_id && data.addTariff.tariff_type_id !== "") {
    newData.company.tariff_type_id = data.addTariff.tariff_type_id;
  }
  if (
    data.addTariff.tariff_fee_period_id &&
    data.addTariff.tariff_fee_period_id !== ""
  ) {
    newData.company.tariff_fee_period_id = data.addTariff.tariff_fee_period_id;
  }
  newData.company.tariff_purchase_date = moment(new Date().getTime()).format(
    "YYYY-MM-DD"
  );
  return newData;
};
